import { PopupRenderer } from './PopupRenderer.js';
import { createIconWithDimensions } from '../IconSizeHelper.js';

export class GeoJsonRenderer {
  constructor(url, options) {
    this.url = url;
    this.options = options;
    this.popupRenderer = new PopupRenderer(options);
  }

  async draw(map) {
    const res = await fetch(this.url);
    const geojson = await res.json();

    // Create custom icon if markerIconUrl is provided
    const customIcon = await createIconWithDimensions(
      this.options.markerIconUrl,
      this.options.markerShadowUrl,
      this.options.debug
    );

    // pointToLayer function for custom marker icons on point features
    const pointToLayer = customIcon 
      ? (feature, latlng) => L.marker(latlng, { icon: customIcon })
      : undefined;

    L.geoJSON(geojson, {
      filter: (feature) => this.options.filterFn(feature, this.options.debug),
      pointToLayer: pointToLayer,
      onEachFeature: async (feature, layer) => {
        // Use PopupRenderer to handle popup creation
        await this.popupRenderer.bindGeoJsonPopup(layer, feature, this.panelRenderer);
      },
    }).addTo(map);
  }

  async showItemInPanel(feature) {
    // This will be called by the panel renderer
    if (this.panelRenderer) {
      await this.panelRenderer.showItemDetails(feature);
    }
  }
}
